import { createFilter } from '@/pages/common/filter-dropdown/create-filter'

export const rolesDropdownModel = createFilter()
